export default {
  labels: {
    agreements: 'Convenios',
    searchByAgreementCode: 'Buscar por código de convenio',
    searchByService: 'Buscar por nombre de servicio',
    payer: 'Pagador',
    services: 'Servicios',
    title: 'Configuración de convenios',
    basicInformation: 'Información básica',
    regulation2275: 'Normativa 2275',
    packageConfiguration: 'Configuración general de armado de cuentas',
    groupsConfiguration: 'Configuración de grupos',
    generalAuditConditions: 'Condiciones generales de auditoría',
    auditRules: 'Reglas de auditoría',
    results: 'Resultados',
    yes: 'Si',
    no: 'No',
    active: 'Activo',
    inactive: 'Inactivo',
    email: 'EMAIL',
    virtualDirectory: 'DIRECTORIO VIRTUAL',
    s3: 'S3',
    api: 'API',
    sftp: 'SFTP',
    singleFile: 'Archivo único',
    sftps3: 'SFTP/S3',
    zip: 'ZIP',
    documentaryType: 'Tipo documental',
    groupingByCode: 'Agrupación por código',
    validate: 'VALIDAR',
    nonValidate: 'NO VALIDAR',
    deleteAuditRule: '¿Está seguro de eliminar la regla de auditoría?',
    pmisToValidate: 'PMIS a validar',
    pos: 'PBS',
    noPos: 'NPBS',
    deleteAuditService: '¿Está seguro de eliminar el servicio {name} de la regla de auditoría?',
    deleteAuditProduct: '¿Está seguro de eliminar el PMIS con nombre {name} de la regla de auditoría?',
    confirm: 'Esta acción no se puede revertir',
    allServicesAdded: 'Todos los servicios han sido agregados.',
    pdf: 'PDF',
    pdfAndZip: 'PDF y ZIP',
    deleteGroup: '¿Está seguro de eliminar el grupo "{name}"?',
    preSettlementConfiguration: 'Configuración de encarpetamiento de relación de envío',
    dynamicFieldVariables: 'Agregar variables',
  },
  supportsConfiguration: {
    title: 'Configuración de soportes',
    requiredSupportsAccount: 'Soportes requeridos para cuenta',
    requiredSupportsCharge: 'Soportes requeridos para cargos',
    search: 'Buscar por código de producto, nombre de soporte o abreviatura',
    supportLevel: 'Nivel de relación',
    supportType: 'Tipo de soporte',
    serviceType: 'Tipo de servicio',
    name: 'Nombre',
    abbrevation: 'Abreviatura',
    pmisCode: 'Código PMIS',
    productName: 'Nombre producto',
    code: 'Código',
    required: 'Requerido'
  },
  agreements: {
    agreementCode: 'Código de convenio',
		agreementName: 'Nombre de convenio',
    payer: 'Pagador',
    serviceTypes: 'Tipos de servicio',
    normative2275: 'Normativa 2275',
  },
  basicInformation: {
    agreementCode: 'Código de convenio',
    sponsorName: 'Aseguradora',
		agreementName: 'Convenio',
    taxIdentificationNumber: 'NIT',
    sponsorType: 'Tipo de aseguradora',
    sponsorCode: 'Código aseguradora',
    requireConcurrentAudit: 'Concurrencia',
    responsible: 'Responsable',
  },
  regulation2275: {
    activateRegulation: 'Activar normativa 2275',
    startDateRegulation: 'Fecha de inicio',
    cuvFormatRegulation: 'Formato CUV',
    cuvFormatTypes: {
      json: 'JSON',
      txt: 'TXT',
      jsonWithValidationResults: 'JSON con resultados de validación',
      txtWithValidationResults: 'TXT con resultados de validación',
    }
  },
  packageConfiguration: {
    deliveryChannel: 'Tipo de entrega',
    exportRoute: 'Destino',
    separateFiles: 'Separar archivos',
    packageFolderName: 'Formato de directorio',
    packageType: 'Tipo de empaquetado',
    exportType: 'Tipo de exportación',
    folderName: 'Directorio del archivo',
    formatFile: 'Nombre del archivo',
    buttons: {
      addGroup: 'Agregar grupo',
    },
    groupName: 'Nombre de grupo',
    formatFileName: 'Nombre del archivo',
    supports: 'Soportes',
    copiesPlaceholder: 'Copias',
    orderPlaceholder: 'Orden',
    tableHeaders: {
      groupName: 'Nombre de grupo',
      groupFolderName: 'Directorio',
      groupFormatFile: 'Nombre del archivo grupal',
      groupSupportsOrderAndCopies: 'Soportes, orden y copias',
      groupActions: 'Acciones',
    },
  },
  zipConfiguration: {
    splitFile: 'Dividir archivos finales',
    fileSize: 'Tamaño máximo del archivo en MB',
    fileSizeHint: 'Tamaño que tendrá cada división del archivo',
    fileSuffix: 'Sufijo de división',
    fileSuffixHint: 'Sufijo que se le asignará a cada división del archivo',
    splitZipFile: 'Dividir archivo ZIP',
    zipFileSize: 'Tamaño máximo del archivo en MB',
    zipFileSizeHint: 'Tamaño que tendrá cada división del archivo ZIP',
    zipFileSuffix: 'Sufijo de división',
    zipFileSuffixHint: 'Sufijo que se le asignará a cada división del archivo ZIP',
    zipFolderName: 'Directorio del paquete ZIP',
    zipFormatFile: 'Nombre archivo ZIP',
  },
  groupsConfiguration: {
    fileCode: 'Código de archivo',
    order: 'Orden',
    copies: 'Copias',
    groupName: 'Nombre de grupo',
    actions: 'Acciones',
  },
  auditRules: {
    service: 'Servicio',
    healthPlan: 'PBS/NPBS',
    invoiceAmount: 'Monto de factura',
    minimumAmount: 'Monto mínimo ({currency})',
    maximumAmount: 'Monto máximo ({currency})',
    auditType: 'Tipo de auditoría',
    actions: 'Acciones',
    validateAmount: 'Validar monto',
    minimumAmountField: 'Monto mínimo',
    maximumAmountField: 'Monto máximo',
    validateService: 'Validar servicio',
    validatePmis: 'Validar PMIS',
    servicesToValidate: 'Agregar servicios',
    code: 'Código',
    name: 'Nombre',
    posOrNoPos: 'PBS/NPBS',
    serviceCode: 'Código de servicio',
    serviceName: 'Nombre de servicio',
    preSettlement: 'Pre radicación',
  },
  buttons: {
    supportConfigurations: 'Configuración de soportes',
    assignResponsible: 'Asignar responsable',
    edit: 'Editar',
    add: 'Agregar',
    addPmis: 'Agregar PMIS',
    addAgreement: 'Agregar convenio',
    save: 'Guardar',
    cancel: 'Cancelar',
    next: 'Siguiente',
    delete: 'Eliminar',
    back: 'Atrás',
  },
  productFinder: {
    selectPmis: 'Seleccionar PMIS',
    search: 'Buscar por código o nombre',
    service: 'Servicio',
    healthCarePlanCoverage: 'PBS/NPBS',
    check: 'Check',
    code: 'Código',
    name: 'Nombre',
    description: 'Descripción',
  },
  messages: {
    errorUpdateAgreement: 'Error al actualizar la información del convenio, por favor intente nuevamente o comuníquese con su equipo de soporte tecnico.',
  },
  buildPackages: {
    title: 'Configuración de encarpetamiento',
    agreementCode: 'Código de convenio',
    agreementName: 'Nombre de convenio',
    packageFolderName: 'Directorio del paquete PDF',
    preview: 'Vista previa',
    multipleFiles: '*Múltiples archivos',
    multipleDirectory: '*Múltiples carpetas',
    splitedFileWarning: '(El archivo se dividirá en partes de {size} MB)',
    duplicatedGroup: 'Ya existe un grupo con el nombre {name} ¿Desea reemplazarlo?',
    duplicatedGroupWarn: 'Esta acción reemplazará la configuración del grupo existente',
    tabs: {
      folding: 'Encarpetamiento',
      supports: 'Soportes',
    },
    categories: {
      general: 'Generales',
      INVOICES: 'Facturas',
      PATIENTS: 'Pacientes',
      PROVIDER_PAYER: 'Prestador - Pagador',
      PRE_SETTLEMENTS: 'Relación de envío',
    },
    fileFormatFields: {
      accountId: 'Id de la cuenta',
      baseAccountId: 'Id de la cuenta base',
      originEventId: 'Id de evento',
      agreementCode: 'Codigo de convenio',
      healthcarePlanCoverage: 'Plan',
      regime: 'Regimen',
      lastServiceType: 'Tipo de servicio',
      lastServiceTypeDescription: 'Descripcion de servicio',
      invoiceSource: 'Fuente de la factura',
      invoiceSerial: 'Serie de factura',
      electronicInvoiceNumber: 'Número de factura digital',
      patientId: 'Id de paciente',
      patientName: 'Nombre de paciente',
      payerName: 'Nombre pagador',
      providerTaxIdentificationNumber: 'NIT del proveedor',
      providerId: 'Id proveedor',
      originInvoiceGroupId: 'Número de relación de envío',
      invoiceNumber: 'Número de factura',
      invoiceNumberRaw: 'Número de factura (Sin prefijo)',
    },
  }
}
